<script module lang="ts">
	import type { ISbStoryData, SbBlokData } from '@storyblok/js';
	import type { ResultOptionProps } from './quizSingleStepResultOption.svelte';
	export interface ResultProps extends SbBlokData {
		component: 'quiz_single_step_result';
		results: Array<ISbStoryData<ResultOptionProps>['content']>;
		info_text: string;
		cta: Array<ISbStoryData<ButtonV3Props>['content']>;
	}
</script>

<script lang="ts">
	import Blok from '$lib/storyblok/blok.svelte';
	import { editable } from '$lib/storyblok/editable';
	import type { ButtonV3Props } from '../buttonV3.svelte';
	import { goto } from '$app/navigation';
	import { getSbUrl } from '$lib/utils/storyblok/url';

	interface Props {
		content: ISbStoryData<ResultProps>['content'];
		resultIndex: number;
		onclose?: () => void;
	}

	let { content, resultIndex, onclose }: Props = $props();
</script>

<div class="flex h-full w-full flex-col justify-center bg-white text-center" use:editable={content}>
	{#if content.results[resultIndex]}
		<Blok content={content.results[resultIndex]} />
	{/if}

	<div class="flex justify-center">
		<p class="mt-5 text-balance rounded-lg bg-green-6 px-3 py-2 text-[14px]/[160%]">
			{content.info_text}
		</p>
	</div>

	<div class="mt-9">
		{#each content.cta as block}
			<Blok
				content={block}
				onclick={() => {
					goto(getSbUrl(block.link));
					onclose?.();
				}}
			/>
		{/each}
	</div>
</div>
